import { useEventDetailsContext } from '../contexts/RingContext';

const useEventUniqueName = () => {
    const { eventUniqueName } = useEventDetailsContext();
    return eventUniqueName;
};

export default useEventUniqueName;
